// extracted by mini-css-extract-plugin
export default {"paginationContainer":"MostRecentOrderTab_paginationContainer__SfXjB"};